import React, { useEffect, useState } from 'react';
import { CCard, CCardBody, CCardHeader, CCol, CRow, CButton, CFormInput, CFormCheck, CInputGroup, CInputGroupText } from '@coreui/react';
import { DataGrid } from '@mui/x-data-grid';
import { Link, useLoaderData } from 'react-router-dom';
import axios from "axios";
import { cilPen, cilPlus, cilTrash } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { confirmAlert } from 'react-confirm-alert';
import { formatUTC } from 'src/store';
import PermissionsNoPage, { Permissions } from "src/components/Permissions";
import Status from 'src/components/tableElements/Status';
import { cilSearch } from '@coreui/icons'
import CustomPagination from 'src/components/pagination/CustomPaginatiion';
import ItemControlModalCustom from 'src/components/item_control_modal/ItemControlModalCustom';
import AxiosInstance from 'src/components/Axios';
import FilterDropdown_main from '../../components/objects/FilterDropdown_main';
import FilterDropdown_main_v1 from '../../components/objects/FilterDropdown_main_v1';
import dayjs from 'dayjs'
import debounce from 'lodash.debounce';
import ActiveFilters from 'src/components/ActiveFilters';


const tokenStr = localStorage.getItem('user');
const user = localStorage.getItem('user_data');
const header = { headers: { "Authorization": `Bearer ${tokenStr}` } };

const page = 1;
const postPerPage = 0;
// const pageSize = 20;
const pageSize = 30;

export async function LoaderObjects() {
  let res = await axios.get(process.env.REACT_APP_SERVER_URL + '/api/objects',
    {
      params: {
        page: page,
        "language.id": 3,
        ...(!Permissions(user, 'Objects', 'SHOW_OBJECTS') && { show: true })
      }
    }, header).then((response) => {
      return response;
    });
  return res;
};

const Objects = () => {
  if (!Permissions(user, 'Objects', 'VIEW_OBJECTS')) {
    return <PermissionsNoPage />;
  }
  const { data } = useLoaderData();
  const [rows, setRows] = useState(false);
  const [loadObjects, setLoadObjects] = useState(false);

  const [rowCountState, setRowCountState] = React.useState(0);
  const [loaders, setLoaders] = useState({attributes: false, collections: false, projects: false, financed: false});

  // стан для модалки видалення і приховування
  const [showItemControlModal, setShowItemControlModal] = useState(false);
  //для чекбокса
  const [selectedIds, setSelectedIds] = useState([]);
  //актуальна сторінка
  const [currentPage, setCurrentPage] = useState(1);

  //ген атрибути
  const [attributes, setAttributes] = useState([])

  //список колекцій
  const [collections, setCollections] = useState([])
  //вибрана колекція
  const [collectionId, setCollectionId] = useState(null);

  //список фінансувань
  const [financed, setFinanced] = useState([])
  //вибране фінансування
  const [financedId, setFinancedId] = useState(null)

  //список проектів
  const [projects, setProjects] = useState([])
  //вибраний проект
  const [projectsId, setProjectsId] = useState(null)

  //стан для списку субайтемів
  const [selectedSubItems, setSelectedSubItems] = useState([]);

  //зберігання слагу країни 
  const [selectedCountrySlug, setSelectedCountrySlug] = useState('')

  //зберігання слагу регіону
  const [selectedRegionSlug, setSelectedRegionSlug] = useState('')

  //стан для статусу проекту(фільтр)
  const [objectsStatus, setObjectsStatus] = useState('')

  // прапорець для пропуску першого виклику ефекту
  const isFirstRender = React.useRef(true)

  //стан для дати date_from
  const [dateFrom, setDateFrom] = useState(null)

  //стан для дати date_to
  const [dateTo, setDateTo] = useState(null)

  //флаг для запиту за обжектами 
  const [makeRequest, setMakeRequest] = useState(false)

  //стан  видимості по фільтру
  const [visibilityFilter, setVisibilityFilter] = useState(undefined)

  // стан для компонента активних фільтрів
  const [activeFilters, setActiveFilters] = useState([])

  //Чи показувати кнопки видалення і приховування в попапі

  const isDelAction = true;
  const isHideAction = true;

  // debounced-функція для пошуку
  const debouncedSearch = React.useMemo(() =>
      debounce((value) => {
        setLoadObjects(true);
        axios.get(process.env.REACT_APP_SERVER_URL + '/api/objects', {
            params: {
              name: value,
              'language.id': 3,
            },
          }, header)
          .then((response) => {
            setLoadObjects(false);
            setRows(response.data['hydra:member']);
          });
      }, 500),
  []);

  // очищення debounce при анмаунті
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  //ефект для відкриття модалки
  useEffect(() => {
    if (selectedIds.length >= 2) {
      setShowItemControlModal(true)
    }
    else {
      setShowItemControlModal(false)
    }
  }, [selectedIds])


  //отримуєм атрибути
  useEffect(() => {
    getAttributes();
    getCollections();
    getProjects();
    getFinanced();
  }, [])

  if (!rows) {
    setRowCountState(data['hydra:totalItems'])
    setRows(data['hydra:member']);
  };


  useEffect(() => {
    if (dateFrom && dateTo) {
      // console.log('request')
      getRowsTable(currentPage)
    } else if (dateFrom === null && dateTo === null && makeRequest === true) {
      getRowsTable(currentPage)
    }
  }, [dateFrom, dateTo, makeRequest])


  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    getRowsTable(currentPage);
  }, [selectedSubItems, currentPage, visibilityFilter, collectionId, projectsId, financedId, objectsStatus]);


  //параметри атрибутів для фільтра
  const buildFilterParams = () => ({
    'show': visibilityFilter === 'visible' ? true : visibilityFilter === 'non_visible' ? false : null,
    'attributeItems': selectedSubItems.filter(item => item.cat[0].slug === 'gen_attr').map(item => item.id),
    'scannings.attributeItems.id': selectedSubItems.filter(item => item.cat[0].slug === 'scan_attr').map(item => item.id),
    'category.id': collectionId,
    'scannings.projects.id': projectsId,
    'scannings.financed.id': financedId,
    'status': objectsStatus ? objectsStatus : undefined,
    'scannings.year[gte]': dateFrom ? dayjs(dateFrom).year()
      : null,
    'scannings.year[lte]': dateTo ? dayjs(dateTo).year()
      : null
  });


  const getRowsTable = (p = 1) => {
    setLoadObjects(true);
    const filterParams = buildFilterParams();
    // console.log('filterParam', filterParams)
    axios.get(`${process.env.REACT_APP_SERVER_URL}/api/objects`, {
      params: {
        page: p,
        "language.id": 3,
        itemsPerPage: 30,
        ...filterParams,
      },
    })
      .then(response => {
        setRows(response.data['hydra:member']);
        setRowCountState(response.data['hydra:totalItems']);
        setLoadObjects(false);
      })
      .catch(error => {
        console.error('Помилка:', error);
      });
  };

  const handlePageChange = (page) => {
    //
    setCurrentPage(page + 1);

    getRowsTable(page + 1);
  };

  function handleSearch(event) {
    const value = event.target.value;
    // якщо менше або дорівнює 3 символам — не шукаємо
    if (value.length <= 3) {
      // скасувати відкладений запит
      debouncedSearch.cancel();
      // якщо поле повністю очищене — повертаємося до стандартного списку
      if (value.length === 0) {
        getRowsTable(currentPage);
      }
      return;
    }
    // якщо більше 3 символів — виконуємо debounced-пошук
    debouncedSearch(value);
  }

  //обробник для чекбокса 
  const handleCheckboxToggle = (id) => {
    setSelectedIds((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id]
    );
  };

  function getAttributes() {
    setLoaders((value)=>{ return {...value, attributes: true} });
    AxiosInstance.get(`/attributes`, {
      headers: { 'accept': 'application/json' }, params: {
        'pagination': false
      }
    }).then((response) => {
      setAttributes(response.data);
      setLoaders((value)=>{ return {...value, attributes: false} });
    }).catch(()=>{
      setLoaders((value)=>{ return {...value, attributes: false} });
    })
  }

  function getCollections() {
    setLoaders((value)=>{ return {...value, collections: true} });
    AxiosInstance.get(`/categories`, {
      headers: { 'accept': 'application/json' }, params: {
        'type': 'objects',
      }
    }).then((response) => {
      setLoaders((value)=>{ return {...value, collections: false} });
      setCollections(response.data)
    }).catch(()=>{
      setLoaders((value)=>{ return {...value, collections: false} });
    })
  }


  function getFinanced() {
    setLoaders((value)=>{ return {...value, financed: true} });
    AxiosInstance.get(`/accounts`, {
      headers: { 'accept': 'application/json' }, params: {
        'pagination': false,
      }
    }).then((response) => {
      setLoaders((value)=>{ return {...value, financed: false} });
      setFinanced(response.data)
    }).catch(()=>{
      setLoaders((value)=>{ return {...value, financed: false} });
    })
  }

  function getProjects() {
    setLoaders((value)=>{ return {...value, projects: true} });
    AxiosInstance.get(`/projects`, {
      headers: { 'accept': 'application/json' }, params: {
        'pagination': false,
        'show': true,
        'language.id': 3
      }
    }).then((response) => {
      setLoaders((value)=>{ return {...value, projects: false} });
      setProjects(response.data)
    }).catch(()=>{
      setLoaders((value)=>{ return {...value, projects: false} });
    })
  }

  //функція для додавання активних фільтрів в стан
  function handleActiveFilters(filterSlug, filterLabel, optionSlug, optionLabel, optionId) {
    setActiveFilters(prev => {
      const filtered = prev.filter(item => item.filterSlug !== filterSlug);
      return [...filtered, { filterSlug, filterLabel, optionSlug, optionLabel, optionId }];
    })
  }


  function handleSubItem(id, slug, cat) {
    setSelectedSubItems(prev => {
      const filtered = prev.filter(item => item.slug !== slug);
      return [...filtered, { slug, id, cat }];
    });
  }

  //функція для очистки регіона

  function removeRegion(items) {
    setSelectedSubItems(items => items.filter(elem => elem.slug !== 'Region'))
    setActiveFilters(activeFilters => activeFilters.filter(elem => elem.filterSlug !== 'Region'))
  }

  //функція для очистки міста

  function removeCity(items) {
    setSelectedSubItems(items => items.filter(elem => elem.slug !== 'Settlement'))
    setActiveFilters(activeFilters => activeFilters.filter(elem => elem.filterSlug !== 'Settlement'))
  }

  //функція для очистки вибраного списку через not set
  function cleanListItem(slug) {
    setActiveFilters(
      activeFilters.filter(elem => elem.filterSlug !== slug)
    )
    if ((slug === 'Visibility' && visibilityFilter === 'visible') || (slug === 'Visibility' && visibilityFilter === 'non_visible')) {
      setVisibilityFilter(undefined)
      return
    }
    else if (slug === "Collection" && collectionId) {
      setCollectionId(null)
      return
    }
    else if (slug === "Projects_scan" && projectsId) {
      setProjectsId(null)
      return
    }
    else if (slug === "Financed" && financedId) {
      setFinancedId(null)
      return
    }
    else if (slug === 'Status') {
      setObjectsStatus('')
      return
    }

    else if (slug === 'Country') {
      setSelectedCountrySlug('')
      setSelectedRegionSlug('')
      setSelectedSubItems(
        selectedSubItems.filter(elem => elem.slug !== slug && elem.slug !== 'Region' && elem.slug !== 'Settlement')

      )
      setActiveFilters(
        activeFilters.filter(elem => elem.filterSlug !== slug && elem.filterSlug !== 'Region' && elem.filterSlug !== 'Settlement')

      )
      return
    }
    else if (slug === 'Region') {
      setSelectedRegionSlug('')
      setSelectedSubItems(
        selectedSubItems.filter(elem => elem.slug !== slug && elem.slug !== 'Settlement')
      )
      setActiveFilters(
        activeFilters.filter(elem => elem.filterSlug !== slug && elem.filterSlug !== 'Settlement')

      )
      return
    }

    else {
      setSelectedSubItems(
        selectedSubItems.filter(elem => elem.slug !== slug)
      )
    }
  }


  function resetAll() {
    setActiveFilters([])
    setVisibilityFilter(undefined)
    setCollectionId(null)
    setProjectsId(null)
    setFinancedId(null)
    setObjectsStatus('')
    setSelectedCountrySlug('')
    setSelectedRegionSlug('')
    setSelectedSubItems([])
    setDateFrom(null)
    setDateTo(null)
    setMakeRequest(true)
  }

  function changeVisibilityOfItems(selectedIds) {
    confirmAlert({
      title: 'Ви впевнені що хочете змінити видимість сторінок ?',
      message: '',
      buttons: [
        {
          label: 'Так',
          onClick: async () => {

            try {
              console.log('ChangeVisibility')
              const fetchedObjects = await Promise.all(
                selectedIds.map(id =>
                  AxiosInstance.get(`/objects/${id}`).then(res => {
                    return res.data
                  })
                )
              );

              const updateRequests = fetchedObjects.map(obj =>
                AxiosInstance.put(`/objects/${obj.id}`, {
                  show: obj.show !== undefined ? !obj.show : false,
                })
              );

              await Promise.all(updateRequests);

              getRowsTable(currentPage);

              setSelectedIds([]);
            } catch (error) {
              console.error('Помилка при оновленні видимості:', error);
            }
          },
        },
        {
          label: 'Ні',
          onClick: () => { },
        },
      ],
    });
  }



  function deleteItems(selectedIds) {
    confirmAlert({
      title: 'Ви впевнені що хочете видалити сторінки ?',
      message: '',
      buttons: [
        {
          label: 'Так',
          onClick: () => {
            console.log('delete')
            const resultItems = selectedIds.map(selectedId => {

              return AxiosInstance.delete(`/objects/${selectedId}`)
            })

            Promise.all(resultItems).then(() => {
              getRowsTable(currentPage)
              setSelectedIds([])
            })
          }
        },
        {
          label: 'Ні',
          onClick: () => {
            return;
          }
        }
      ]
    });
  }

  function Deleted(row) {
    confirmAlert({
      title: 'Ви впевнені що хочите видалити цей пункт ?',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Так',
          onClick: () => {
            AxiosInstance.delete('/objects/' + row.id).then(()=> {
              getRowsTable(currentPage);
            }).catch(err => {
              console.log("delete err", err);
            });
          }
        },
        {
          label: 'Ні',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  function Hidden(row) {
    confirmAlert({
      title: 'Ви впевнені що хочите змінити пункт ?',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Так',
          onClick: () => {
            // axios.put(process.env.REACT_APP_SERVER_URL + '/api/objects/' + row.id, { show: row.show !== undefined ? !row.show : false }, header)
            //   .then(() => {
            //     getRowsTable(currentPage);
            //   });
            // змінити всі show у children translations якщо змінюєм батька
            axios.put(process.env.REACT_APP_SERVER_URL + '/api/objects/' + row.id, { show: row.show !== undefined ? !row.show : true }, header).then(() => {
              if (row.translations.length > 0) {
                const updatePromises = row.translations.map(translate =>
                  axios.put(process.env.REACT_APP_SERVER_URL + '/api/objects/' + translate.id, { show: row.show !== undefined ? !row.show : true }, header)
                );
                Promise.all(updatePromises)
                  .then(() => {
                    getRowsTable(currentPage);
                  })
                  .catch(err => {
                    console.log("update show translations err", err);
                  });
              } else {
                getRowsTable(currentPage);
              }
            });
          }
        },
        {
          label: 'Ні',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      width: 350,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const isChecked = selectedIds.includes(params.row.id);

        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => handleCheckboxToggle(params.row.id)}
              style={{
                accentColor: isChecked ? '#227965' : '#ccc',
                cursor: 'pointer',
                width: '20px',
                height: '20px',
              }}
            />
            {params.row.name}
          </div>
        );
      }
    },
    {
      field: 'Location',
      headerName: 'Location',
      width: 300,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const location = params.row.attributeItems?.length > 0 && params.row.attributeItems.filter((variation => {
          return variation.attribute.slug.includes('Settlement') || variation.attribute.slug.includes('Region');
        }))

        return <div>
          {location && location.map((address, index) => {
            return <span key={address.id}>{address.name}{index !== (location.length - 1) && ','} </span>
          })}
        </div>
      }
    },
    {
      field: 'showStatus',
      headerName: 'Visibility',
      headerAlign: 'center',
      align: 'center',
      // sortable: true,
      sortable: false,
      disableColumnMenu: true,
      width: 100,
      renderCell: (params) => {
        return <Status type={params.row.show ? 'visible' : 'hidden'} />
      }
    },
    {
      field: 'id',
      headerName: 'ID',
      headerAlign: 'center',
      align: 'center',
      width: 70,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'dateEntered',
      headerName: 'Creation date',
      type: 'datetime',
      headerAlign: 'center',
      align: 'center',
      width: 150,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <div>{formatUTC(params.row.dateEntered)}</div>
      }
    },
    {
      field: "show",
      headerName: "",
      headerClassName: "hide-header",
      align: 'center',
      width: 70,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <button disabled={!Permissions(user, 'Objects', 'HIDE_OBJECTS')} className='transparent' onClick={() => Hidden(params.row)}>
          {params.row.show ? <img src="/show.svg" alt="show" /> : <img src="/hidden.svg" alt="hidden" />}
        </button>
      }
    },
    {
      field: "action",
      headerName: "",
      headerClassName: "hide-header",
      align: 'center',
      width: 70,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <Link to={'/objects/update/' + params.row.id}><img src="/edit.svg" alt="edit" /></Link>;
      }
    },
    {
      field: "delete",
      headerName: "",
      headerClassName: "hide-header",
      align: 'center',
      width: 70,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <button className='transparent' onClick={() => Deleted(params.row)}><img src="/delete.svg" alt="delete" /></button>
      }
    },

  ];


  return (
    <CRow>
      <CCol xs={12}
        style={{ marginLeft: 'auto', marginRight: 'auto' }}
      >
        <CCard className="mb-4 mt-4">
          <CCardHeader
            className='items_card_header'
          >
            {/* <strong> */}
            {/* Об'єкти */}
            Objects
            {/* </strong> */}
            <small></small>
          </CCardHeader>
          <CCardBody>
            {/* Блок додавання і пошуку */}
            <div className='head_items_wrapper_with_filter'>
              <p className="text-medium-emphasis small"
                style={{ order: '3' }}
              >
                <Link to="/objects/create" className='link_add_button'><CButton className='item_add_button' color="secondary"><CIcon icon={cilPlus} customClassName="nav-icon" height={15} />
                  {/* Створити */}
                  Add
                </CButton></Link>
              </p>

              <FilterDropdown_main_v1
                attributes={attributes}
                collections={collections}
                collectionId={collectionId}
                setCollectionId={setCollectionId}
                financed={financed}
                setFinancedId={setFinancedId}
                financedId={financedId}
                projects={projects}
                setProjectsId={setProjectsId}
                projectsId={projectsId}
                handleSubItem={handleSubItem}
                selectedSubItems={selectedSubItems}
                setSelectedSubItems={setSelectedSubItems}
                selectedCountrySlug={selectedCountrySlug}
                setSelectedCountrySlug={setSelectedCountrySlug}
                selectedRegionSlug={selectedRegionSlug}
                setSelectedRegionSlug={setSelectedRegionSlug}
                setMakeRequest={setMakeRequest}
                visibilityFilter={visibilityFilter}
                setVisibilityFilter={setVisibilityFilter}
                removeRegion={removeRegion}
                removeCity={removeCity}
                cleanListItem={cleanListItem}
                objectsStatus={objectsStatus}
                setObjectsStatus={setObjectsStatus}
                dateFrom={dateFrom}
                setDateFrom={setDateFrom}
                dateTo={dateTo}
                setDateTo={setDateTo}
                resetAll={resetAll}
                handleActiveFilters={handleActiveFilters}
                activeFilters={activeFilters}
                loaders={loaders}

              />
              <CInputGroup
                style={{ order: '1' }}
                className="mb-3 item_add_input_wrapper_round"
              >
                <CInputGroupText style={{ backgroundColor: 'transparent', border: 'none', padding: 0, paddingLeft: '10px' }}>
                  {/* <CIcon icon={cilSearch} /> */}
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
                      stroke="#767781"
                      strokeWidth="1.66667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </CInputGroupText>
                <CFormInput
                  className="item_add_input_round"
                  type="search"
                  placeholder="Search"
                  onChange={handleSearch}
                />
              </CInputGroup>
            </div>
            {/* Блок додавання і пошуку(верх) */}

            {/* Блок додавання активних фільтрів */}
            <ActiveFilters
              activeFilters={activeFilters}
              dateFrom={dateFrom}
              dateTo={dateTo}
              setDateFrom={setDateFrom}
              setDateTo={setDateTo}
              setMakeRequest={setMakeRequest}
              cleanListItem={cleanListItem}
            />
            {/* Блок додавання активних фільтрів (верх)*/}


            <div className='data-grid-wrapper'
            // style={{ height: 600, width: '100%' }}
            >
              <DataGrid
                rows={rows}
                columns={columns}
                pageSize={
                  // 30
                  pageSize
                }
                loading={loadObjects}
                disableSelectionOnClick
                rowsPerPageOptions={[30]}
                pagination
                rowCount={rowCountState}
                paginationMode="server"
                onPageChange={handlePageChange}
                components={{ Pagination: CustomPagination }}
                headerHeight={44}
                getRowClassName={(params) =>
                  selectedIds.includes(params.row.id) ? 'active-row' : ''
                }
                sx={{
                  borderRadius: '12px',
                  border: '1px solid #ccc',

                  '& .MuiDataGrid-main': {
                    // borderRadius: '12px',
                  },
                  '& .MuiDataGrid-columnHeaders': {
                    borderTopLeftRadius: '12px',
                    borderTopRightRadius: '12px',
                    fontFamily: 'Inter',
                    fontWeight: '600',
                    fontSize: '12px',
                    lineheight: '150%',
                    color: '#717680',
                    //   borderBottom: '2px solid #4e73df',
                  },
                  '& .MuiDataGrid-cell': {
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: '14px',
                    color: '#434349',
                  },
                  '& .MuiDataGrid-footerContainer': {
                    // borderBottomLeftRadius: '12px',
                    // borderBottomRightRadius: '12px',
                  },
                  // Full overlay to block interactions
                  '& .MuiDataGrid-overlay': {
                    position: 'absolute',
                    inset: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.4)',
                    backdropFilter: 'blur(2px)',
                    WebkitBackdropFilter: 'blur(2px)',
                    zIndex: 9,
                    pointerEvents: 'all',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  },
                  // Loader color (CircularProgress)
                  '& .MuiDataGrid-overlay .MuiCircularProgress-root': {
                    color: '#000000',
                    zIndex: 10
                  },
                  // If LinearProgress overlay is used
                  '& .MuiLinearProgress-root': {
                    backgroundColor: 'rgba(0, 0, 0, 0.15)',
                  },
                  '& .MuiLinearProgress-bar': {
                    backgroundColor: '#000000',
                  },
                }}
              />

              <ItemControlModalCustom
                show={showItemControlModal}
                setShow={setShowItemControlModal}
                setSelectedIds={setSelectedIds}
                changeVisibilityOfItems={changeVisibilityOfItems}
                deleteItems={deleteItems}
                selectedIds={selectedIds}
                rows={rows}
                isDelAction={isDelAction}
                isHideAction={isHideAction}

              />
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow >
  );
};

export default Objects;